import React from 'react';

import { getMetaError } from 'shared/functions';

import type { FieldRenderProps } from 'react-final-form';

import { Tiptap } from './ui';
import { tipTapPluginsMode } from './constants';

interface TipTapWrapperProps extends FieldRenderProps<any, HTMLElement> {
  pluginsMode?: tipTapPluginsMode;
}

export const TipTapWrapper: React.FC<TipTapWrapperProps> = ({ input, meta, pluginsMode, ...props }) => {
  const error = getMetaError(meta);

  return (
    <div>
      <Tiptap onChange={(value) => input.onChange(value)} content={input.value} pluginsMode={pluginsMode} {...props} />
      {error && (
        <div className="errorMsg" style={{ whiteSpace: 'pre-wrap' }}>
          {error}
        </div>
      )}
    </div>
  );
};
